import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';

export interface Handle404ErrorComponentAttrs {
  errorModel: any;
  modelLabel: string;
}

export default class Handle404ErrorComponent extends Component<Handle404ErrorComponentAttrs> {
  @tracked errorModel: any;

  get is404Error() {
    return (
      this.errorModel?.errors?.firstObject?.status === '404' ||
      this.errorModel?.message.match(
        /^Attempted to handle event `loadingData` on .+ while in state root\.deleted\.saved/,
      ) != null
    );
  }

  refreshBrowser = () => {
    window.location.reload();
  };
}
